import React from 'react';
import styles from './styles.module.scss';

import { ReactComponent as Star } from '../../../assets/icons/icon-star-filled.svg';
import { ReactComponent as StarEmpty } from '../../../assets/icons/icon-star-outline.svg';

const Rating = ({ value }) => (
  <div className={styles.rating}>
    {value >= 1 ? <Star /> : <StarEmpty />}
    {value >= 2 ? <Star /> : <StarEmpty />}
    {value >= 3 ? <Star /> : <StarEmpty />}
    {value >= 4 ? <Star /> : <StarEmpty />}
    {value >= 5 ? <Star /> : <StarEmpty />}
  </div>
);

export default Rating;
